import { Trans } from '@lingui/react/macro';

import { isWebImageType } from '@/modules/annotator/annotation-utils/annotation-utils';
import { useLatestImagesV2 } from '@/react-query/useLatestImagesv2';

interface ImageCarouselProps {
  visitId: number;
  patientId: string;
  selectedImageId: string;
  onImageSelect: (imageId: string) => void;
}

export const ImageCarousel = ({
  visitId,
  patientId,
  selectedImageId,
  onImageSelect,
}: ImageCarouselProps) => {
  const { data: images, isLoading } = useLatestImagesV2({
    videaPatientId: patientId,
    estimatedVisitId: visitId.toString(),
  });

  const imagesToDisplay =
    images?.analyses
      ?.filter(
        (image) =>
          image.imageType === 'BITEWING' || image.imageType === 'PERIAPICAL',
      )
      ?.map((image) => ({
        imageId: String(image.imageId),
        imageType: image.imageType,
        thumbnailUrl: isWebImageType(image.path)
          ? image.path
          : image.originalPath,
      })) || [];

  if (imagesToDisplay.length === 0 && !isLoading) {
    return <div>No images found</div>;
  }

  return (
    <div className="vai-flex vai-flex-col vai-gap-3">
      <div>
        <Trans>Step 2: Select an Image</Trans>
      </div>
      <div className="vai-flex vai-gap-2 vai-overflow-x-auto vai-pb-2 vai-max-w-[1100px]">
        {imagesToDisplay.map((image) => (
          <button
            key={image.imageId}
            onClick={() => onImageSelect(image.imageId)}
            className={`vai-flex-shrink-0 vai-w-24 vai-h-24 vai-border-2 vai-rounded-lg vai-transition-all vai-cursor-pointer hover:vai-shadow-md ${
              selectedImageId === image.imageId
                ? 'vai-border-blue-500 vai-bg-blue-50'
                : 'vai-border-gray-300 vai-bg-white'
            }`}
          >
            {image.thumbnailUrl ? (
              <div
                className="vai-w-full vai-h-full vai-bg-gray-200 vai-rounded"
                style={{
                  backgroundImage: `url(${image.thumbnailUrl})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
            ) : (
              <div className="vai-flex vai-items-center vai-justify-center vai-w-full vai-h-full vai-bg-gray-200 vai-rounded vai-text-xs vai-text-gray-500">
                {image.imageType}
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
